import Messages from './Messages';
import i18n from '../../translations/i18n';
import initApp from '../../util/init-app';

initApp({
  i18n,
  render: (h) => h(Messages),
});
